import { DashboardBarChart } from "@aidkitorg/types/lib/admin-panel/dashboard";
import React, { useEffect, useState } from "react";
import { generateDistroSummaryKind } from "../../../utils/adminPanel.utils";

export type XAxis = {
  title: string,
  dataField: string,
}

export type YAxis = {
  title: string,
  aggregation: string,
  dataField: string,
}

export const useBarChartFormState = (component?: DashboardBarChart) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  
  const [xAxis, setXAxis] = useState<XAxis>({
    title: '', dataField: ''
  })
  const [yAxis, setYAxis] = useState<YAxis>({
    title: '',
    aggregation: 'Count',
    dataField: '',
  })

  useEffect(() => {
    if (!component) return

    const componentTitle = 'title' in component && component.title
      ? typeof component.title === 'string'
        ? component.title
        : component.title['en']
      : 'Dashboard Component';
    setTitle(componentTitle)
    setDescription(component.description || '')

    const groups = component.groups
    if (groups.length === 1 && groups[0].kind === 'Field') {
      setXAxis({
        title: component.xAxisLabel || '',
        dataField: groups[0].field
      })
    }
    const yAxisSummary: YAxis = {
      title: component.yAxisLabel || '',
      aggregation: component.summary.kind,
      dataField: ''
    }

    if (component.summary.kind === 'Sum' || component.summary.kind === 'Mean') {
      if (component.summary.value.kind === 'Field') {
        yAxisSummary.dataField = component.summary.value.field
      }
    }
    setYAxis(yAxisSummary)
  }, [component])

  const buildBarChartObject = (): DashboardBarChart => {
    const barChart: DashboardBarChart = {
      kind: 'Bar Chart',
      title: title,
      description: description,
      summary: generateDistroSummaryKind(yAxis.aggregation, yAxis.dataField),
      groups: [{
        kind: 'Field',
        field: xAxis.dataField
      }],
      xAxisLabel: xAxis.title,
      yAxisLabel: yAxis.title
    }

    return barChart
  }
  const isFormStateValid =
    title !== '' &&
    xAxis.title !== '' &&
    xAxis.dataField !== '' &&
    yAxis.title !== '' &&
    (yAxis.aggregation === 'Count' || yAxis.dataField !== '')

  return {
    title, setTitle,
    description, setDescription,
    xAxis, setXAxis,
    yAxis, setYAxis,
    buildBarChartObject,
    isFormStateValid,
  }
}